import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { IDENTITY, REQUIRES_CONFIRMATION } from "@/lib/constants";

const SiteConfigContext = createContext({ config: { whatsapp_number: "85298548459" }, refresh: () => {} });

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState({ tawk_property_id: "", tawk_widget_id: "", whatsapp_number: "85298548459" });

  const refresh = async () => {
    try {
      const r = await api.get("/config");
      setConfig((c) => ({ ...c, ...r.data }));
      if (r.data?.favicon_url) {
        let link = document.querySelector("link[rel='icon']");
        if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
        link.href = r.data.favicon_url;
      }
    } catch { /* keep defaults */ }
  };

  useEffect(() => { refresh(); }, []);

  return <SiteConfigContext.Provider value={{ config, refresh }}>{children}</SiteConfigContext.Provider>;
}

export const useSiteConfig = () => useContext(SiteConfigContext);

// Centralized business/legal identity — merges live admin config over defaults.
// Empty legal fields (reg number, jurisdiction) surface as "Requires Confirmation".
export function useIdentity() {
  const { config } = useSiteConfig();
  const c = config || {};
  const val = (k, fb) => (c[k] != null && String(c[k]).trim() !== "" ? c[k] : fb);
  const rc = (k) => (c[k] && String(c[k]).trim() ? c[k] : REQUIRES_CONFIRMATION);
  return {
    legalName: val("company_legal_name", IDENTITY.legal_name),
    displayName: val("company_display_name", IDENTITY.display_name),
    regNumber: rc("company_reg_number"),
    jurisdiction: rc("company_jurisdiction"),
    office: val("company_office", IDENTITY.office),
    email: val("company_email", IDENTITY.email),
    phone: val("company_phone", IDENTITY.phone),
    website: val("company_website", IDENTITY.website),
  };
}
